<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
      <div class="row p-3" v-if="currentTab === 'Basic'">
        <organization-basic ref="basic" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Address'">
        <organization-address ref="address" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Contact'">
        <organization-contact ref="contact" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Logo' && !isAdd">
        <organization-logo ref="logo" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Config' && !isAdd">
        <organization-config ref="config" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Links' && !isAdd">
        <organization-links ref="links" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Emails' && !isAdd">
        <organization-emails
          ref="emails"
          @valid="emailsValid"
          @saveIt="emailsSaveIt"
          @message="showMessage"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Members' && !isAdd">
        <organization-members ref="members" @message="showMessage" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Programs' && !isAdd">
        <organization-programs ref="programs" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Storage' && !isAdd">
        <organization-storage ref="storage" :isOrg="true" />
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span title="org id">#{{ ids }}</span>
        </div>
        <div class="col-md-7">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-4">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(false)"
            >
              Save
            </button>
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(true)"
            >
              Save and Close
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTabs from '@/Components/ZElements/Tabs'
import OrganizationBasic from '@/Components/Organizations/forms/organization-basic'
import OrganizationLogo from '@/Components/Organizations/forms/organization-logo'
import OrganizationConfig from '@/Components/Organizations/forms/organization-config'
import OrganizationAddress from '@/Components/Organizations/forms/organization-address'
import OrganizationContact from '@/Components/Organizations/forms/organization-contact'
import OrganizationLinks from '@/Components/Organizations/forms/organization-links'
import OrganizationEmails from '@/Components/Organizations/forms/organization-emails'
import OrganizationMembers from '@/Components/Organizations/forms/organization-members'
import OrganizationPrograms from '@/Components/Organizations/forms/organization-programs'
import OrganizationStorage from '@/Components/Organizations/forms/organization-storage'
export default {
  name: 'organization-dialog',
  components: {
    ZDialog,
    ZTabs,
    OrganizationBasic,
    OrganizationLogo,
    OrganizationConfig,
    OrganizationAddress,
    OrganizationContact,
    OrganizationLinks,
    OrganizationEmails,
    OrganizationMembers,
    OrganizationPrograms,
    OrganizationStorage,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
      currentTab: 'Basic',
      // tabs: [
      //   'Basic',
      //   'Address',
      //   'Contact',
      //   'Logo',
      //   'Config',
      //   'Links',
      //   'Emails',
      //   'Coaches',
      // ],
      validEmails: false,
      isSave: false,
      validErrors: [],
      invalidMessage: '',
    }
  },
  mounted() {
    this.currentTab = 'Basic'
    this.isSave = false
    this.validErrors = []
    this.invalidMessage = ''
  },
  computed: {
    ...mapGetters('users', ['isFeatureAllowed']),
    ...mapGetters('organizations', ['organization']),
    isVisible() {
      return this.show !== null
    },
    tabs() {
      let _tabs = ['Basic', 'Address', 'Contact']
      if (!this.isAdd) {
        _tabs.push('Logo')
        _tabs.push('Links')
        _tabs.push('Emails')
        _tabs.push('Members')
      }
      if (this.isFeatureAllowed('organization_config')) {
        _tabs.push('Config')
      }
      if (this.isFeatureAllowed('organization_programs')) {
        _tabs.push('Programs')
      }
      if (this.isFeatureAllowed('organization_storage')) {
        _tabs.push('Storage')
      }
      return _tabs
    },
    isAdd() {
      let _is = false
      if (this.show) {
        if (this.show.isAdd) {
          _is = true
        }
      }
      return _is
    },
    title() {
      let _title = 'Edit Organization'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Organization'
        } else if (this.organization) {
          _title = `Edit Organization (${this.organization.orgName})`
        }
      }
      return _title
    },
    ids() {
      let _ids = ''
      if (this.organization) {
        _ids = this.organization.id
      }
      return _ids
    },
  },
  methods: {
    ...mapActions('organizations', ['saveOrganization']),
    showTab(value) {
      if (this.show.isAdd) {
        this.currentTab = value
      } else {
        let saved = false
        if (this.isSave) {
          saved = this.performSave(false)
        } else {
          saved = true
        }
        if (saved) {
          this.currentTab = value
          this.isSave = false
        }
      }
    },
    emailsValid(valid) {
      this.validEmails = valid
    },
    emailsSaveIt(saveIt) {
      console.log('Email Templates changed...', {
        saveIt: saveIt,
        validEmails: this.validEmails,
      })
      this.isSave = saveIt
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.currentTab === 'Emails') {
        this.$refs.emails.validate()
        if (this.isSave && this.validEmails) {
          valid = true
        } else {
          valid = false
        }
      } else {
        if (this.organization.orgName === '') {
          valid = false
          this.validErrors.push('name')
        }
        if (this.organization.orgCode === '') {
          valid = false
          this.validErrors.push('group code')
        }
        if (this.show.isAdd) {
        }
      }
      return valid
    },
    async performSave(closeIt) {
      let success = false
      let valid = this.validate()
      if (valid) {
        // Save Here
        success = true
        let saved = null
        console.log('Saved', {
          closeId: closeIt,
          isAdd: this.show.isAdd,
          organization: this.organization,
        })
        this.isSave = false
        if (this.currentTab === 'Emails') {
          await this.$refs.emails.saveEmailTemplates()
        } else {
          let results = await this.saveOrganization(this.organization)
          if (results) {
            saved = {
              id: results.id,
              name: results.OrgName,
            }
          }
        }
        this.$emit('saved', saved)
        if (closeIt || this.show.isAdd) {
          this.currentTab = 'Basic'
          this.$emit('close')
        }
      } else {
        this.isSave = true
        this.invalidMessage = 'missing ' + this.validErrors.join(', ')
      }
      return success
    },
    showMessage(message) {
      let $this = this
      this.invalidMessage = message
      setTimeout(() => {
        $this.invalidMessage = ''
      }, 4000)
    },
    close() {
      this.currentTab = 'Basic'
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
</style>
